import { useEffect, useState } from "react";
import { approvalApi } from "../api/approvalApi";

/**
 * 상신 가능한 양식 목록을 서버에서 받아 그룹별로 묶는다.
 *
 * 예전엔 `FORM_TYPES` 상수 7개를 하드코딩해 그렸다. 그래서 양식을 DB 로 옮겨도 화면에는
 * 여전히 7개만 나왔다. 이 훅이 그 하드코딩을 대체한다 — 관리자가 양식을 추가하면
 * 프론트 배포 없이 목록에 나타난다.
 *
 * 결재선·열람자는 서버가 이미 '실제 사람'으로 풀어서 준다. 프론트가 소속팀장 조회나
 * 스킵 규칙을 다시 구현하지 않는 이유는, 그렇게 하면 화면에 보인 결재선과 서버가 실제로
 * 만드는 결재선이 어긋날 수 있기 때문이다.
 */
export function useSelectableForms(open) {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!open) return;
        let cancelled = false;
        setLoading(true);
        setError(null);

        approvalApi.forms()
            .then((res) => {
                if (cancelled) return;
                const list = Array.isArray(res) ? res : (res?.data ?? []);
                setForms(list);
            })
            .catch((e) => {
                if (cancelled) return;
                setForms([]);
                setError(e);
            })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
    }, [open]);

    /** 그룹 순서를 유지한 채 [{ groupCode, groupName, forms: [...] }] 로 묶는다. */
    const groups = [];
    for (const f of forms) {
        let g = groups.find((x) => x.groupCode === f.groupCode);
        if (!g) {
            g = { groupCode: f.groupCode, groupName: f.groupName, forms: [] };
            groups.push(g);
        }
        g.forms.push(f);
    }

    return { forms, groups, loading, error };
}
